import { ListStoreDefault, ListRequestHandler, ListFilterHandler, ListSuccessHandler } from 'js/helpers/reducers.js';

import {
  PROFILE_VIEW_MOUNTED,
  FETCH_USER_COMPETITORS,
  FETCHED_USER_COMPETITORS,
  FETCH_USER_SUBSCRIPTIONS,
  FETCHED_USER_SUBSCRIPTIONS,
  SET_USER_COMPETITORS_FILTER,
  SET_USER_SUBSCRIPTIONS_FILTER,
  FETCH_SETTINGS_BRANDS_LIST,
  FETCHED_SETTINGS_BRANDS_LIST,
  SET_SETTINGS_BRANDS_FILTER,
  FETCH_SETTINGS_PUBLISHERS_LIST,
  FETCHED_SETTINGS_PUBLISHERS_LIST,
  SET_SETTINGS_PUBLISHERS_FILTER,
  CREATED_USER_COMPETITOR,
  CREATED_USER_BRAND_SUBSCRIPTION,
  REMOVED_USER_COMPETITOR,
  REMOVED_USER_SUBSCRIPTION,
 } from 'components/Pages/Settings/actions.js';

const defaultState = {
  competitorsList: ListStoreDefault({
    page_size: 40,
    page_num: 1,
  }),
  subscriptionsList: ListStoreDefault({
    page_size: 40,
    page_num: 1,
  }),
  brandsList: ListStoreDefault({
    page_size: 40,
    page_num: 1,
  }),
  publishersList: ListStoreDefault({
    page_size: 40,
    page_num: 1,
  }),
  profileMounted: false,
};

const addUserCompetitor = (state, action) => {
  const newListData = [action.competitor, ...state.competitorsList.data];
  const store = { ...state.competitorsList, data: newListData };
  return { ...state, competitorsList: store };
};

const addUserSubscription = (state, action) => {
  const newListData = [action.subscription, ...state.subscriptionsList.data];
  const store = { ...state.subscriptionsList, data: newListData };
  return { ...state, subscriptionsList: store };
};

const removeUserCompetitor = (state, action) => {
  const id = action.id;
  let newListData = [...state.competitorsList.data];
  newListData = newListData.filter(el => el.public_id !== id);
  const store = { ...state.competitorsList, data: newListData };
  return { ...state, competitorsList: store };
};

const removeUserSubscription = (state, action) => {
  const id = action.id;
  let newListData = [...state.subscriptionsList.data];
  newListData = newListData.filter(el => el.public_id !== id);
  const store = { ...state.subscriptionsList, data: newListData };
  return { ...state, subscriptionsList: store };
};

const SettingsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    case PROFILE_VIEW_MOUNTED:
      return Object.assign({}, state, { profileMounted: true });
    // competitors
    case FETCH_USER_COMPETITORS:
      return ListRequestHandler(state, action, 'competitorsList');
    case CREATED_USER_COMPETITOR:
      return addUserCompetitor(state, action);
    case REMOVED_USER_COMPETITOR:
      return removeUserCompetitor(state, action);
    case FETCHED_USER_COMPETITORS:
      return ListSuccessHandler(state, action, 'competitorsList');
    case SET_USER_COMPETITORS_FILTER:
      return ListFilterHandler(state, action, 'competitorsList');
    // subscriptions
    case FETCH_USER_SUBSCRIPTIONS:
      return ListRequestHandler(state, action, 'subscriptionsList');
    case FETCHED_USER_SUBSCRIPTIONS:
      return ListSuccessHandler(state, action, 'subscriptionsList');
    case CREATED_USER_BRAND_SUBSCRIPTION:
      return addUserSubscription(state, action);
    case REMOVED_USER_SUBSCRIPTION:
      return removeUserSubscription(state, action);
    case SET_USER_SUBSCRIPTIONS_FILTER:
      return ListFilterHandler(state, action, 'subscriptionsList');
    case FETCH_SETTINGS_BRANDS_LIST:
      return ListRequestHandler(state, action, 'brandsList');
    case FETCHED_SETTINGS_BRANDS_LIST:
      return ListSuccessHandler(state, action, 'brandsList');
    case SET_SETTINGS_BRANDS_FILTER:
      return ListFilterHandler(state, action, 'brandsList');
    case FETCH_SETTINGS_PUBLISHERS_LIST:
      return ListRequestHandler(state, action, 'publishersList');
    case FETCHED_SETTINGS_PUBLISHERS_LIST:
      return ListSuccessHandler(state, action, 'publishersList');
    case SET_SETTINGS_PUBLISHERS_FILTER:
      return ListFilterHandler(state, action, 'publishersList');
    default:
      return Object.assign({}, state);
  }
};

export default SettingsReducer;
